import { AxiosResponse } from 'axios';

import {
  IConfirmKnowledgeAreaLevelRequest,
  IKnowledgeAreaLevelConfirmation,
} from './knowledge-area-level-confirmation.interface';

import { axiosApiInstance } from 'services/config';

class KnowledgeAreaLevelConfirmationApi {
  async confirm(
    requestData: IConfirmKnowledgeAreaLevelRequest,
  ): Promise<IKnowledgeAreaLevelConfirmation> {
    const response: AxiosResponse<IKnowledgeAreaLevelConfirmation> =
      await axiosApiInstance.post('level-confirmation', requestData);
    return response.data;
  }

  async clear(accountId: number, knowledgeAreaId: number): Promise<void> {
    await axiosApiInstance.delete(
      `level-confirmation/account/${accountId}/knowledge-area/${knowledgeAreaId}`,
    );
  }

  async getOne(
    accountId: number,
    knowledgeAreaId: number,
  ): Promise<IKnowledgeAreaLevelConfirmation> {
    const response: AxiosResponse<IKnowledgeAreaLevelConfirmation> =
      await axiosApiInstance.get(
        `level-confirmation/account/${accountId}/knowledge-area/${knowledgeAreaId}`,
      );
    return response.data;
  }

  async getByAccount(accountId: number): Promise<IKnowledgeAreaLevelConfirmation[]> {
    const response: AxiosResponse<IKnowledgeAreaLevelConfirmation[]> =
      await axiosApiInstance.get(`level-confirmation/account/${accountId}`);
    return response.data;
  }
}

export { KnowledgeAreaLevelConfirmationApi };
